/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {
    Debug,
    Messenger,
    RenderDocument,
    Asset as RenderAsset
} from "js_renderer";
import Model from "./model";
import IAsset from "./asset_interface";

/*
 *  SceneAPI.Model is wrapper for the cadwork.webgl.Model class
 */
export default
class Asset extends Model implements IAsset {

    constructor(aRenderDocument: RenderDocument, aModelUrl: string, aDescriptionUrl: string, aHiddenByDefault: boolean) {
        super(aRenderDocument, aModelUrl, aDescriptionUrl, aHiddenByDefault, false);
    }

    public draw(): boolean {
        if (this._renderModel) {
            Debug.logInfo("Asset is already drawn.");
            return false;
        }

        this._renderModel = new RenderAsset(
            this._renderDocument.getSceneAPI(),
            this,
            this._renderDocument,
            this.modelUrl,
            this.descriptionUrl,
            this._transformation,
            this.hiddenByDefault
        );

        this._renderDocument.addModel(this._renderModel);

        return true;
    }
}
